import { CommonModule } from '@angular/common';
import { Component, computed, effect, input, output, signal, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
  CslSchemaSelectorComponent,
  SfoUiJSONSchema7,
} from 'projects/ui-components/src/public-api';
import { Reference, ReferenceDraft } from '../../reference.model';
import { debounceTime, Subject, takeUntil } from 'rxjs';

export interface ReferenceEditorData {
  cslSchemas: SfoUiJSONSchema7[];
}

@Component({
  selector: 'sfo-reference-editor',
  templateUrl: './reference-editor.component.html',
  styleUrls: ['./reference-editor.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, CslSchemaSelectorComponent],
})
export class ReferenceEditorComponent implements OnDestroy {
  private formValue = signal<object | null>(null);
  private delayFormValueEmission$ = new Subject<object>();
  private destroy$ = new Subject<void>();

  readonly reference = input.required<Reference | ReferenceDraft>();
  readonly cslSchemas = input.required<SfoUiJSONSchema7[]>();
  updateReference = output<Reference>();

  constructor() {
    this.delayFormValueEmission$
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.emitReferenceUpdate(value);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cslData = computed(() => {
    return this.reference()?.['csl'] || null;
  });

  onFormValueChange(value: object) {
    this.formValue.set(value);
    this.delayFormValueEmission$.next(value);
  }

  private emitReferenceUpdate(value: object) {
    const updatedReference: Reference = {
      ...this.reference(),
      csl: {
        ...this.reference()?.['csl'],
        ...value,
      },
    };

    this.updateReference.emit(updatedReference);
  }
}
